import { apiClient } from "./api-client";

const BASE_PATH = "/ReportingHelper";

export const thumbnailApi = {
  /**
   * Fetch a dynamically generated thumbnail for a report.
   * @param reportName - The report display name (e.g., "Assembly By Group")
   */
  async getThumbnail(reportName: string): Promise<Blob> {
    const params = new URLSearchParams({ reportName });
    return apiClient.getBlob(`${BASE_PATH}/GetThumbnailImage?${params}`);
  },
};
